<template>
  <v-card
    class="v-card--wizard"
    elevation="12"
  >
    <v-card-title
      v-if="title"
      class="justify-center display-2 font-weight-light pt-5"
    >
      {{ title }}
    </v-card-title>

    <div
      v-if="subTitle"
      class="text-center display-1 grey--text font-weight-light mb-6"
    >
      {{ subTitle }}
    </div>

    <v-tabs
      ref="tabs"
      v-model="internalValue"
      color="white"
      class="d-none d-sm-block"
      centered
      slider-size="50"
      :background-color="backgroundColor"
      @change="$emit('tab:change')"
    >
      <v-tabs-slider
        class="mt-1"
        :color="color"
      />

      <v-tab
        v-for="(item, i) in items"
        :key="i"
        :ripple="false"
        :disabled="!availableSteps.includes(i)"
      >
        {{ item }}
      </v-tab>
    </v-tabs>

    <base-wizard-actions
      class="d-flex d-sm-none"
      :internal-value="internalValue"
      :color="color"
      :available-steps="availableSteps"
      :items="items"
      @click:prev="$emit('click:prev')"
      @click:next="$emit('click:next')"
    >
      <template v-slot:buttons>
        <slot name="buttons" />
      </template>
    </base-wizard-actions>

    <v-progress-linear
      v-if="loading"
      indeterminate
    />

    <div class="my-6" />

    <v-card-text>
      <v-tabs-items v-model="internalValue">
        <slot />
      </v-tabs-items>
    </v-card-text>

    <base-wizard-actions
      :internal-value="internalValue"
      :color="color"
      :available-steps="availableSteps"
      :items="items"
      @click:prev="$emit('click:prev')"
      @click:next="$emit('click:next')"
    >
      <template v-slot:buttons>
        <slot name="buttons" />
      </template>
    </base-wizard-actions>
  </v-card>
</template>

<script>
  // Mixins
  import Proxyable from 'vuetify/lib/mixins/proxyable'

  export default {
    name: 'BaseMaterialWizard',

    mixins: [Proxyable],

    props: {
      title: {
        type: String,
        default: null,
      },
      subTitle: {
        type: String,
        default: null,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      color: {
        type: String,
        default: 'success',
      },
      availableSteps: {
        type: Array,
        default: () => ([]),
      },
      items: {
        type: Array,
        default: () => ([]),
      },
    },

    computed: {
      backgroundColor () {
        return this.color + ' lighten-5'
      },
    },
  }
</script>

<style lang="sass">
  .v-card--wizard
    overflow: visible
    padding: 0

    .v-tabs-bar
      height: 56px
      padding: 0 8px

    .v-tabs-slider-wrapper
      overflow: visible

    .v-tabs-slider
      border-radius: 4px

    .v-tabs-slider-wrapper
      contain: initial
      z-index: 0
</style>
